import { create } from "zustand";

const useCompanyStore = create((set) => ({
  company: null,
  setCompany: (company) => {
    set({ company });
  },
}));

export default useCompanyStore;
